import Notification from 'components/ui/base/notification/Notification';
import { useState } from 'react';
import { getErrorMessage } from 'utils/getErrorMessage';

interface Props {
    onSubmit: Function;
}

const useLoadingButton = ({ onSubmit }: Props) => {
    const [loading, setIsLoading] = useState(false);

    const handleOnPressButton = async () => {
        setIsLoading(true);

        try {
            await onSubmit();
        } catch (err) {
            const errorMessage = getErrorMessage(err);
            Notification({
                type: 'error',
                messageTitle: 'Operation Failed',
                description: errorMessage || 'Could not complete the requested operation. Please try again.',
                placement: 'top',
            });
        } finally {
            setIsLoading(false);
        }
    };

    return {
        loading,
        handleOnPressButton,
    };
};
export default useLoadingButton;
